import React, { Fragment } from 'react';
import {Text, View, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    logo: {
      width: 70,
        height: 40,
  },
 
  });


  const FooterImage = ({invoice}) =>{
    var invoice1 = (JSON.stringify(invoice));
    var invoice2 = JSON.parse(invoice1);
    var invoice3 = JSON.parse(invoice2);
 
    return(
       <Fragment>
           <View>
           {/* <Image style={styles.logo} src={invoice3?.agentdetails?.agentimageurl} /> */}
           {invoice3?.markupdata?.hideBrandingLogo == false?(
                        <Image style={styles.logo}  src="images/logo/seyLogo.png" />):(<></>)}
           </View>
    </Fragment>
      );
 
   } 
   export default FooterImage